export interface FoundationVulnerabilityInput {
  foundationId: string;
  yearType: string;
}
